import axios from 'axios';
import { API_BASE_URL } from './urls.js';


const axiosClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Request Interceptor: Attach the JWT token to every outgoing request.
 */
axiosClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Response Interceptor: Handle global errors like token expiration and billing issues.
 */
axiosClient.interceptors.response.use(
    (response) => {
        // If the request was successful, just return the response
        return response;
    },
    (error) => {
        // 1. Extract error details from the response
        const { response } = error;
        const status = response?.status;
        const errorCode = response?.data?.code;

        // 2. Handle Token Expiration or Invalid Token (401)
        if (status === 401 && (errorCode === 'TOKEN_EXPIRED' || errorCode === 'INVALID_TOKEN')) {
            console.warn("Authentication required or token expired. Redirecting to login.");
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('stripeAccountId');
            // Redirect the user to the login page (must be outside the component context)
            window.location.href = '/login?session_expired=true';
            return Promise.reject(error);
        }

        // 3. Handle Subscription Canceled (403 with custom code)
        if (status === 403 && errorCode === 'SUBSCRIPTION_CANCELED') {
            console.warn("Organization subscription canceled. Redirecting to billing page.");
            // Redirect to a specific page for billing/reactivation
            setTimeout(() => {
                window.location.href = '/subscriptions/manage'; 

            },2000)
            return Promise.reject(error);
        }

        // For all other errors (404, 500, etc.), reject the promise so the component can handle it
        return Promise.reject(error);
    }
);

export default axiosClient;